import { useMemo } from 'react';

import useTrls from 'hooks/translation/useTrls';

import { CampaignErrors } from 'store/models/createCampaign';
import { useSelector } from 'store/utils';

const TrlKeys = {
    totalBudgetIsEmpty: 'AdCreate.AdForm.AdTotalBudget.TOTAL_BUDGET_IS_EMPTY',
};

export type ValidationErrors = Partial<CampaignErrors> | undefined;

export const useGetValidateErrors = (): ValidationErrors => {
    const adTotalBudget = useSelector((state) => state.createCampaign.adTotalBudget);
    const adTotalBudgetNoLimits = useSelector((state) => state.createCampaign.adTotalBudgetNoLimits);
    const trls = useTrls();

    const errors: Partial<CampaignErrors> = useMemo(
        () => ({
            adTotalBudgetNoLimits:
                !adTotalBudgetNoLimits && !adTotalBudget ? trls(TrlKeys.totalBudgetIsEmpty) : undefined,
        }),
        [adTotalBudget, adTotalBudgetNoLimits, trls]
    );

    const result = useMemo(
        () =>
            Object.fromEntries(
                Object.entries(errors).filter(([, value]) => {
                    return value !== undefined;
                })
            ),
        [errors]
    );

    return result;
};
